import { createAction } from 'redux-actions'
import {
  GET_DATA_SOURCES,
  GET_DATA_SOURCES_FAILED,
  GET_DATA_SOURCES_SUCCEEDED,
  SYNC_DATA_SOURCE,
  SYNC_DATA_SOURCE_FAILED,
  SYNC_DATA_SOURCE_SUCCEEDED,
  GET_EMAIL_PROVIDERS,
  GET_EMAIL_PROVIDERS_FAILED,
  GET_EMAIL_PROVIDERS_SUCCEEDED,
  CONNECT_DATA_SOURCE,
  CONNECT_DATA_SOURCE_FAILED,
  CONNECT_DATA_SOURCE_SUCCEEDED,
  DISCONNECT_DATA_SOURCE,
  DISCONNECT_DATA_SOURCE_FAILED,
  DISCONNECT_DATA_SOURCE_SUCCEEDED,
  GET_PLAID_CONNECTIONS,
  GET_PLAID_CONNECTIONS_FAILED,
  GET_PLAID_CONNECTIONS_SUCCEEDED,
  GET_WORKATO_CONNECTIONS,
  GET_WORKATO_CONNECTIONS_FAILED,
  GET_WORKATO_CONNECTIONS_SUCCEEDED,
} from 'Redux/Types/DataSourceTypes'

export const getDataSources = createAction(GET_DATA_SOURCES)
export const getDataSourcesFailed = createAction(GET_DATA_SOURCES_FAILED)
export const getDataSourcesSucceeded = createAction(GET_DATA_SOURCES_SUCCEEDED)

export const syncDataSource = createAction(SYNC_DATA_SOURCE)
export const syncDataSourceFailed = createAction(SYNC_DATA_SOURCE_FAILED)
export const syncDataSourceSucceeded = createAction(SYNC_DATA_SOURCE_SUCCEEDED)

export const getEmailProviders = createAction(GET_EMAIL_PROVIDERS)
export const getEmailProvidersFailed = createAction(GET_EMAIL_PROVIDERS_FAILED)
export const getEmailProvidersSucceeded = createAction(GET_EMAIL_PROVIDERS_SUCCEEDED)

export const connectDataSource = createAction(CONNECT_DATA_SOURCE)
export const connectDataSourceFailed = createAction(CONNECT_DATA_SOURCE_FAILED)
export const connectDataSourceSucceeded = createAction(CONNECT_DATA_SOURCE_SUCCEEDED)

export const disconnectDataSource = createAction(DISCONNECT_DATA_SOURCE)
export const disconnectDataSourceFailed = createAction(DISCONNECT_DATA_SOURCE_FAILED)
export const disconnectDataSourceSucceeded = createAction(DISCONNECT_DATA_SOURCE_SUCCEEDED)

export const getPlaidConnections = createAction(GET_PLAID_CONNECTIONS)
export const getPlaidConnectionsFailed = createAction(GET_PLAID_CONNECTIONS_FAILED)
export const getPlaidConnectionsSucceeded = createAction(GET_PLAID_CONNECTIONS_SUCCEEDED)

export const getWorkatoConnections = createAction(GET_WORKATO_CONNECTIONS)
export const getWorkatoConnectionsFailed = createAction(GET_WORKATO_CONNECTIONS_FAILED)
export const getWorkatoConnectionsSucceeded = createAction(GET_WORKATO_CONNECTIONS_SUCCEEDED)
